import { FacultyCard, LoadingListCard } from "Admin/Components";
import { List } from "antd";
import { useEffect, useState } from "react";
import styles from "./FacultyProfileList.module.scss";
import { getFacultyList } from "Admin/Service/Faculty";
import { handleAPIResponse } from "Admin/Utils/HandleAPIResponse";
const FacultyProfileList = () => {
  const [filters, setFilters] = useState({ name: null });
  const [data, setData] = useState({ data: [], isLoading: false });
  const [pagination, setPagination] = useState({
    page: 1,
    rowsPerPage: 16,
    totalRows: 0,
  });
  useEffect(() => {
    getFacultyList(filters.name, (res) => {
      handleAPIResponse(res, () => {
        setData({ data: res.data.faculties, isLoading: false });
        if (res.data.total) {
          setPagination({ ...pagination, totalRows: res.data.total });
        }
      });
    });
  }, []);
  return (
    <div className={styles["faculty-profile-list"]}>
      <LoadingListCard
        isLoading={data.isLoading}
        grid={{
          gutter: 25,
          column: 4,
        }}
        componentNum={16}
        component={
          <div className={styles["content-venue"]}>
            <List
              grid={{
                gutter: 25,
                column: 4,
              }}
              dataSource={data.data}
              renderItem={(item, index) => {
                return (
                  <List.Item key={index}>
                    <FacultyCard data={item} />
                  </List.Item>
                );
              }}
            />
          </div>
        }
      />
    </div>
  );
};

export default FacultyProfileList;
